import React, { useState, useEffect, useRef } from "react";
import "./weighing-control.css";
import Header from "../../components/header/Header";
import NoCheckIcon from "../../../../../assets/imgs/amc-domestico/NoGen.svg";
import GenIcon from "../../../../../assets/imgs/amc-domestico/gen.svg";
import axios from "axios";
import * as XLSX from "xlsx";
import { useForm } from "react-hook-form";
import Overlay from "react-bootstrap/Overlay";

function WeighingControl() {
  const [shipments, setShipments] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFiltering, setIsFiltering] = useState(false);
  const [showOverlay, setShowOverlay] = useState({
    turn: false,
    start: false,
    end: false,
  });

  const containerRef = useRef(null);
  const turnRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setError,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true });
  const turn = watch("turn");
  const start = watch("start");
  const end = watch("end");

  const onSubmit = async (data) => {
    setIsFiltering(true);
    if (new Date(data.start) > new Date(data.end)) {
      setError("start", {
        type: "manual",
        message: "La fecha de inicio no puede ser mayor que la de fin",
      });
      return;
    }

    const dateStart = formatDate(data.start);
    const dateEnd = formatDate(data.end);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard?startDate=${dateStart}&finishDate=${dateEnd}&turn=${data.turn}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments(res.data.shipments || []);
        setHasMore(false);
      }
    } catch (error) {
      setIsFiltering(false);
      console.error(error);
    }
  };

  function formatDate(dateISO) {
    const [year, month, day] = dateISO.split("-");
    return `${day}/${month}/${year}`;
  }

  const clearFilters = async () => {
    setIsFiltering(false);
    reset();
    setPage(1);
    setHasMore(true);
    setShipments([]);
    await getData();
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 1 && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const getData = async () => {
    setIsFiltering(false);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard?page=${page}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        if (res.data.shipments.length > 0) {
          setShipments((prevData) => [...prevData, ...res.data.shipments]);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Etiqueta emitida";
      case 2:
        return "Pesaje";
      case 3:
        return "Documentando";
      case 4:
        return "finalizado";
      case 5:
        return "Cancelado Pesador";
      case 6:
        return "Cancelado Mostrador";
      default:
        return "";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 1:
        return "validated";
      case 2:
        return "in-process";
      case 3:
        return "documenting";
      case 4:
        return "approved";
      case 5:
        return "cancel";
      case 6:
        return "cancel";
      default:
        return "";
    }
  };

  const handleKeyDown = async (e, id) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
      try {
        const res = await axios.put(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/description_inspection/${id}`,
          { description: e.target.value },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "light-load-token"
              )}`,
            },
          }
        );

        if (res.data.code === 1) {
          setPage(1);
          setShipments([]);
          getData();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleTypeShipment = async (e, id) => {
    const type = e.target.value;
    e.target.blur();
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/inspection_type/${id}`,
        { type: parseInt(type) },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setPage(1);
        setShipments([]);
        getData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTypeShipments = (type) => {
    switch (type) {
      case 1:
        return "RX";
      case 2:
        return "ETD";
      case 3:
        return "Manual";
      default:
        return "";
    }
  };

  const finishInspection = async (id, value) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/status_inspection/${id}`,
        { status: parseInt(value) },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setPage(1);
        setShipments([]);
        getData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getInpectionTextShipments = (type) => {
    switch (type) {
      case 0:
        return "Incorrecto";
      case 1:
        return "Correcto";
      default:
        return "";
    }
  };

  const exportToExcel = () => {
    const filteredData = shipments.map(
      ({
        turn_number,
        tag_number,
        created_at,
        awb,
        merchandise_description,
        inspection_description,
        destination,
        pieces,
        inspection_type,
        status,
        inspection_status,
      }) => ({
        Turno: turn_number || "-",
        Embarque: tag_number || "-",
        "Hora emisión": created_at || "-",
        Guía: awb || "-",
        Descripción: merchandise_description || "-",
        Observaciones: inspection_description || "-",
        Destino: destination || "-",
        Piezas: pieces || "-",
        "Tipo de inspección": getTypeShipments(inspection_type) || "-",
        Estatus: status ? getStatusText(status) : "-",
        Inspección:
          inspection_status !== undefined && inspection_status !== null
            ? getInpectionTextShipments(inspection_status)
            : "-",
      })
    );

    // Crear hoja de cálculo
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Obtener rango de datos para aplicar formato de tabla
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    const tableRef = XLSX.utils.encode_range(range);

    // Aplicar formato de tabla
    worksheet["!autofilter"] = { ref: tableRef };

    // Crear libro y agregar la hoja
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Weighing Data");

    // Guardar archivo
    XLSX.writeFile(workbook, "WeighingData.xlsx");
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!isFiltering && container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [hasMore, isFiltering]);

  useEffect(() => {
    if (!isFiltering) {
      getData();
    }
  }, [page]);

  return (
    <>
      <div className="weighing-container">
        <Header />
        <div className="body-weighing">
          <div className="title-body-weighing">
            <h4>Inspección</h4>
          </div>

          <div className="table-container" ref={containerRef}>
            <div className="actions-container">
              <div className="filter">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <label>Turno</label>
                  <input
                    type="text"
                    id="turn"
                    className="turn"
                    {...register("turn", {
                      required: "Este campo es obligatorio",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Solo se permiten números",
                      },
                    })}
                    ref={(e) => {
                      register("turn").ref(e);
                      turnRef.current = e;
                    }}
                    onFocus={() =>
                      setShowOverlay((prev) => ({ ...prev, turn: true }))
                    }
                    onBlur={() =>
                      setShowOverlay((prev) => ({ ...prev, turn: false }))
                    }
                    style={errors.turn ? { borderColor: "red" } : {}}
                  />
                  <Overlay
                    target={turnRef.current}
                    show={!!errors.turn && showOverlay.turn}
                    placement="top"
                  >
                    {(props) => (
                      <div
                        {...props}
                        style={{
                          backgroundColor: "rgba(255, 0, 0, 0.85)",
                          padding: "5px 10px",
                          color: "white",
                          borderRadius: 4,
                          fontSize: 12,
                          zIndex: 9999,
                          marginBottom: "10px",
                          ...props.style,
                        }}
                      >
                        {errors.turn?.message}
                      </div>
                    )}
                  </Overlay>

                  <label>Fecha inicio</label>
                  <input
                    type="date"
                    id="start"
                    className="start"
                    {...register("start", {
                      required: "Selecciona una fecha de inicio",
                      validate: (value) => {
                        if (start && end && new Date(value) > new Date(end)) {
                          return "La fecha de inicio no puede ser mayor que la de fin";
                        }
                        return true;
                      },
                    })}
                    ref={(e) => {
                      register("start").ref(e);
                      startRef.current = e;
                    }}
                    onFocus={() =>
                      setShowOverlay((prev) => ({ ...prev, start: true }))
                    }
                    onBlur={() =>
                      setShowOverlay((prev) => ({ ...prev, start: false }))
                    }
                    style={errors.start ? { borderColor: "red" } : {}}
                  />
                  <Overlay
                    target={startRef.current}
                    show={!!errors.start && showOverlay.start}
                    placement="top"
                  >
                    {(props) => (
                      <div
                        {...props}
                        style={{
                          backgroundColor: "rgba(255, 0, 0, 0.85)",
                          padding: "5px 10px",
                          color: "white",
                          borderRadius: 4,
                          fontSize: 12,
                          zIndex: 9999,
                          marginBottom: "10px",
                          ...props.style,
                        }}
                      >
                        {errors.start?.message}
                      </div>
                    )}
                  </Overlay>

                  <label>Fecha fin</label>
                  <input
                    type="date"
                    id="end"
                    className="end"
                    {...register("end", {
                      required: "Selecciona una fecha de fin",
                    })}
                    ref={(e) => {
                      register("end").ref(e);
                      endRef.current = e;
                    }}
                    onFocus={() =>
                      setShowOverlay((prev) => ({ ...prev, end: true }))
                    }
                    onBlur={() =>
                      setShowOverlay((prev) => ({ ...prev, end: false }))
                    }
                    style={errors.end ? { borderColor: "red" } : {}}
                  />
                  <Overlay
                    target={endRef.current}
                    show={!!errors.end && showOverlay.end}
                    placement="top"
                  >
                    {(props) => (
                      <div
                        {...props}
                        style={{
                          backgroundColor: "rgba(255, 0, 0, 0.85)",
                          padding: "5px 10px",
                          color: "white",
                          borderRadius: 4,
                          fontSize: 12,
                          zIndex: 9999,
                          marginBottom: "10px",
                          ...props.style,
                        }}
                      >
                        {errors.end?.message}
                      </div>
                    )}
                  </Overlay>

                  <button
                    type="submit"
                    className="btn_filter"
                    id="btn_filter"
                    disabled={!turn || !start || !end}
                  >
                    Filtrar
                  </button>
                  <button
                    type="button"
                    className="dlt_filter"
                    id="dlt_filter"
                    onClick={clearFilters}
                  >
                    Borrar filtros
                  </button>
                </form>
              </div>
              <div className="export">
                <button
                  className="export_btn"
                  disabled={shipments.length === 0}
                  onClick={exportToExcel}
                >
                  Expotar
                </button>
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th># Turno</th>
                  <th># Embarque</th>
                  <th>Hora emisión</th>
                  <th># Guía</th>
                  <th>Descripción</th>
                  <th>Observaciones</th>
                  <th>Destino</th>
                  <th>Piezas</th>
                  <th>Tipo de inspección</th>
                  <th>Estatus</th>
                  <th>inspección</th>
                </tr>
              </thead>

              <tbody>
                {shipments.map((row, index) => (
                  <tr key={index}>
                    <td>{row.turn_number ? row.turn_number : "-"}</td>
                    <td>{row.tag_number ? row.tag_number : "-"}</td>
                    <td>{row.created_at ? row.created_at : "-"}</td>
                    <td>{row.awb ? row.awb : "-"}</td>
                    <td>
                      {row.merchandise_description
                        ? row.merchandise_description
                        : "-"}
                    </td>
                    <td style={{ padding: 0 }}>
                      <textarea
                        className="observations"
                        onKeyDown={(e) => handleKeyDown(e, row.id)}
                        defaultValue={row?.inspection_description}
                        disabled={"inspection_status" in row}
                        readOnly={"inspection_status" in row}
                      ></textarea>
                    </td>
                    <td>{row.destination ? row.destination : "-"}</td>
                    <td>{row.pieces ? row.pieces : "-"}</td>
                    <td style={{ padding: 0 }}>
                      {"inspection_status" in row ? (
                        getTypeShipments(row.inspection_type)
                      ) : (
                        <select
                          className="inspection"
                          name="inspection"
                          id="inspection"
                          value={row.inspection_type ?? 1}
                          onChange={(e) => handleTypeShipment(e, row.id)}
                        >
                          <option value={1}>RX</option>
                          <option value={2}>ETD</option>
                          <option value={3}>Manual</option>
                        </select>
                      )}
                    </td>
                    <td>
                      <span className={`status ${getStatusClass(row?.status)}`}>
                        {row.status ? getStatusText(row.status) : "-"}
                      </span>
                    </td>
                    <td>
                      {"inspection_status" in row ? (
                        getInpectionTextShipments(row.inspection_status)
                      ) : (
                        <div className="actions">
                          <button
                            className="check-btn"
                            onClick={() => finishInspection(row.id, 1)}
                          >
                            <img
                              src={GenIcon}
                              alt="check"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </button>
                          <button
                            className="no-check-btn"
                            onClick={() => finishInspection(row.id, 0)}
                          >
                            <img
                              src={NoCheckIcon}
                              alt="no Check"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default WeighingControl;
